import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=d142e216&scoped=true"
import script from "./Mall.vue?vue&type=script&lang=js"
export * from "./Mall.vue?vue&type=script&lang=js"
import style0 from "./Mall.vue?vue&type=style&index=0&id=d142e216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142e216",
  null
  
)

export default component.exports